import React, { Component } from "react";
import { Chart } from "react-google-charts";
import api from "../config.json";
import axios from "../httpServices/httpService";
import auth from "../httpServices/authService";
import pako from "pako";
import decodeJson from "./decodeResponse";
import { getMasterData } from "./masterDataCache";
import RefreshRate from "./GetRefreshRate";
import TopStripLoader from "../Common/TopLoaderComponenet";
import { LIVE_BATCH_SIZE } from "./liveBatches";

// Relay overlay. `showRelay` highlights relay-connected machines' row labels; `showRelayStates`
// (the "Show Relay States" toggle) also draws every relay channel ON / OFF / BLINK window as an
// extra bar on that machine's row.
const RELAY_LABEL_COLOR = "#6f42c1";
const RELAY_LABEL_MARK = "⚡ ";
const RELAY_STATE_COLORS = { OFF: "#6f42c1", ON: "#20c997", BLINK: "#fd7e14" };
const RELAY_ROW_PATTERN = /^Relay (ON|OFF|BLINK) - /;

const escapeHtml = (value) =>
  String(value == null ? "" : value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const isRelayRow = (row) => Array.isArray(row) && typeof row[1] === "string" && RELAY_ROW_PATTERN.test(row[1]);

// True when any active equipment has a Signal mapped to a relay DeviceId + channel (same rule the
// server uses for "relay-connected"). Used to hide the relay toggles when nothing is wired up.
export const hasRelayConfigured = (equipments) =>
  Array.isArray(equipments) &&
  equipments.some(
    (equip) =>
      equip &&
      equip.IsActive !== false &&
      ((equip.Relay && equip.Relay.Signals) || []).some((signal) => signal && signal.DeviceId && signal.RelayId)
  );

export class MachineStateChart extends Component {
  chartref = React.createRef();
  countdownRef = React.createRef(); // for direct DOM updates
  scrollContainerRef = React.createRef(); // for scroll position preservation

  state = {
    timeLineData: [],
    querySuccess: false,
    rawData: [],
    requestNumber: 0,
    updateState: {},
    rowHeight: 0,
    timeLinePos: 0,
    filterObj: {},
    filterBy: {},
    JobView: { JobView: false, ViewCount: 0 },
    autoScrolObj: {},
    cacheData: [],
    updateStateChart: false,
    favourate: false,
    refreshIntervalMs: null,
    lastUpdatedTime: null,
    relayOverlay: { connected: [], intervals: [] },
  };
  relayRequestId = 0; // drops relay overlay responses that arrive after a newer request
  _isMounted = false;
  MyInterval = null; // will be used to reference the single countdown timer
  CountdownInterval = null; // not used separately now (kept for clarity)
  currentCountdown = 0; // store countdown value without triggering re-renders
  savedScrollPosition = 0; // store scroll position
  isRefreshing = false; // guard to prevent overlapping refresh calls

  handleScroll = (e) => { };

  // Update countdown display without triggering component re-render
  updateCountdownDisplay = (seconds) => {
    if (this.countdownRef.current) {
      this.countdownRef.current.textContent = `Refresh in ${seconds}s`;
    }
  };

  // Save current scroll position
  saveScrollPosition = () => {
    const timelineElement = document.getElementById('timeline');
    if (timelineElement) {
      this.savedScrollPosition = timelineElement.scrollTop || 0;
    }
  };

  // Restore scroll position after data refresh
  restoreScrollPosition = () => {
    const timelineElement = document.getElementById('timeline');
    if (timelineElement && this.savedScrollPosition > 0) {
      timelineElement.scrollTop = this.savedScrollPosition;
    }
  };

  getFilterData = (data, filterKey) => {
    let arr = [...data];
    data = [];
    Object.keys(this.props.filterBy).forEach((key) => {
      // console.log("vsdlkkvdslv",arr,this.props.filterBy,key)
      let filterData = arr.filter(
        (one) => one.EquipmentGroup == key && this.props.filterBy[key]
      );
      data = [...data, ...filterData];
    });
    if (filterKey.SortBy == "Descending") {
      data = data.sort(function (a, b) {
        if (a.Equipment < b.Equipment) {
          return 1;
        } else if (a.Equipment > b.Equipment) {
          return -1;
        }
        return 0;
      });
    }
    if (filterKey.SortBy == "Ascending") {
      data = data.sort(function (a, b) {
        if (a.Equipment < b.Equipment) {
          return -1;
        } else if (a.Equipment > b.Equipment) {
          return 1;
        }
        return 0;
      });
    }
    return data;
  };

  componentDidUpdate(prevProps) {
    // "Show Relay States" toggled: add / drop the relay bars on the current timeline.
    if (prevProps.showRelayStates !== this.props.showRelayStates) {
      this.setState({ timeLineData: this.applyRelayOverlay(this.state.timeLineData) });
    }

    if (this.state.filterObj && Object.keys(this.state.filterObj).length > 0) {
      if (
        JSON.stringify(this.state.filterBy) !==
        JSON.stringify(this.props.filterBy) ||
        this.state.filterObj.SortBy !== this.props.filterObj.SortBy ||
        this.state.filterObj.JobView !== this.props.filterObj.JobView
      ) {
        let result = this.getFilterData(
          this.state.rawData,
          this.props.filterObj
        );
        if (this.props.filterObj.JobView) {
          result = this.organiseTimeLineDataWithJobs(result);
        } else {
          result = this.organiseTimeLineData(result);
        }
        this.setState({
          timeLineData: result,
          filterBy: this.props.filterBy,
          filterObj: this.props.filterObj,
          querySuccess: false,
          networkError: false
        });
      }
    }

    if (this.props.reportType == "History") {
      const JobView = { ...this.state.JobView };
      const jobView = { ...this.props.jobView };
      if (jobView) {
        if (
          this.props.jobView.JobView == JobView.JobView &&
          JobView.ViewCount == 0
        ) {
          let res = [];
          if (this.props.jobView.JobView) {
            res = this.organiseTimeLineDataWithJobs(this.props.data);
          } else {
            res = this.organiseTimeLineData(this.props.data);
          }

          JobView.JobView = this.props.jobView.JobView;
          JobView.ViewCount = JobView.ViewCount + 1;
          this.setState({
            timeLineData: res,
            JobView: JobView,
            rawData: this.props.data,
            rowHeight: res.length,
            networkError: false
          });
        }
        if (
          this.props.jobView.JobView !== JobView.JobView &&
          JobView.ViewCount == 1
        ) {
          let res = [];
          if (this.props.jobView.JobView) {
            res = this.organiseTimeLineDataWithJobs(this.props.data);
          } else {
            res = this.organiseTimeLineData(this.props.data);
          }
          JobView.JobView = this.props.jobView.JobView;
          JobView.ViewCount = 0;
          this.setState({
            timeLineData: res,
            JobView: JobView,
            rawData: this.props.data,
            rowHeight: res.length,
          });
        }
        if (this.props.filterView && JobView.ViewCount == 1) {
          let res = [];
          if (this.props.jobView.JobView) {
            res = this.organiseTimeLineDataWithJobs(this.props.data);
          } else {
            res = this.organiseTimeLineData(this.props.data);
          }
          JobView.JobView = this.props.jobView.JobView;
          JobView.ViewCount = 0;
          this.props.setFilterView(false);
          this.setState({
            timeLineData: res,
            JobView: JobView,
            rawData: this.props.data,
            rowHeight: res.length,
          });
        }
      }
    }
    // console.log("componet Did update4", this.props.handleUpdatechart);

    if (this.props.handleUpdatechart == true && this.props.handleUpdatechart) {
      this.UpdateMachineState(this.props.updateData);
      this.props.handelupdate(false, "");
      this.setState({ updateStateChart: this.props.handleUpdatechart, networkError: false });
    }
  }
  UpdateMachineState = async (data) => {
    // console.log("Received Data:", data);

    try {
      // Fetch equipment data
      const Equipment = await getMasterData("equipment");
      const equips = Equipment.filter(one => one.IsActive);
      const user = auth.getCurrentUser();
      let raw = [...this.state.rawData];

      // Collect all matching equipment objects
      const matchedEquips = [];
      for (const item of data) {
        const selectedEquip = equips.find((one) => one.EquipmentID === item.Equipment);
        if (!selectedEquip) {
          console.warn(`EquipmentID ${item.Equipment} not found in equipment data.`);
          continue;
        }
        matchedEquips.push(selectedEquip);
      }

      // Send requests in batches of 5
      const batchSize = LIVE_BATCH_SIZE;
      for (let i = 0; i < Math.ceil(matchedEquips.length / batchSize); i++) {
        const batch = matchedEquips.slice(i * batchSize, (i + 1) * batchSize);

        const compressedData = pako.gzip(
          JSON.stringify({ UserId: user._id, Equips: batch })
        );
        try {
          const result = await axios.put(
            api.liveBaseURL + "GetMachineActvityForLiveReport",
            compressedData, {
            headers: {
              "Content-Encoding": "gzip",
              "Content-Type": "application/json",
            },
          }
          );

          const decompressedData = decodeJson(result.data);
          const jsonData = decompressedData;

          if (jsonData.length > 0) {
            for (const updatedEquip of jsonData) {
              const existingIndex = raw.findIndex((one) => one.Equipment === updatedEquip.Equipment);
              if (existingIndex !== -1) {
                raw[existingIndex] = updatedEquip;
              } else {
                raw.push(updatedEquip);
              }
            }
          }
        } catch (err) {
          // swal(`Error updating batch: ${err.message}`);
        }
      }

      // Process and update state
      const filteredData = this.getFilterData(raw, this.props.filterObj);
      const timeLineData = this.organiseTimeLineData(filteredData);

      this.setState({
        timeLineData,
        rowHeight: timeLineData.length,
        rawData: raw,
        filterBy: this.props.filterBy,
        filterObj: this.props.filterObj,
        requestNumber: this.state.requestNumber + 1,
        networkError: false,
      });
    } catch (err) {
      // swal(`Error fetching equipment: ${err.message}`);
      this.setState({ querySuccess: false, networkError: true });
    }
  };

  refreshLiveData = async () => {
    if (!this._isMounted) return;
    try {
      // Save scroll position before data refresh
      this.saveScrollPosition();
      this.setState({ querySuccess: true, networkError: false });

      const batchSize = LIVE_BATCH_SIZE;
      const Equipment = await this.props.storeDataInLocalStorage("equipment");
      let equips = Equipment.filter(one => one.IsActive);
      let user = auth.getCurrentUser();
      let raw = [];
      // send batch requests
      for (let i = 0; i < Math.ceil(equips.length / batchSize); i++) {
        let startIndex = i * batchSize;
        let endIndex = (i + 1) * batchSize;
        let senddata = equips.slice(startIndex, endIndex);

        const compressedData = pako.gzip(
          JSON.stringify({ UserId: user._id, Equips: senddata })
        );

        try {
          let result = await axios.put(
            api.liveBaseURL + "GetMachineActvityForLiveReport",
            compressedData,
            {
              headers: {
                "Content-Encoding": "gzip",
                "Content-Type": "application/json",
              },
            }
          );

          const decompressedData = decodeJson(result.data);
          const jsonData = decompressedData;

          if (jsonData.length > 0) {
            raw.push(...jsonData);
          }
        } catch (err) {
          this.setState({ querySuccess: false });
          if (
            err.response &&
            err.response.data &&
            err.response.data.code == 901
          ) {
            // swal(`${err.response.data.message}`);
          }
        }
      }

      // Once all batches processed, do final data transformation
      let result = this.getScrollData(raw);
      result = this.getFilterData(result, this.props.filterObj);

      if (this.state.filterObj.JobView) {
        result = this.organiseTimeLineDataWithJobs(result);
      } else {
        result = this.organiseTimeLineData(result);
      }

      // ✅ One final state update
      this.setState({
        networkError: false,
        timeLineData: result,
        cacheData: raw,
        rowHeight: result.length,
        rawData: raw,
        filterBy: this.props.filterBy,
        filterObj: this.props.filterObj,
        requestNumber: this.state.requestNumber + 1,
        querySuccess: false,
        lastUpdatedTime: new Date()
      }, () => {
        // Restore scroll position after state update completes
        setTimeout(() => this.restoreScrollPosition(), 100);
      });
      this.fetchRelayOverlay(raw);
    } catch (err) {
      this.setState({ querySuccess: false, networkError: true });
      // toast.success(`${err}`, {
      //   position: "bottom-right",
      //   autoClose: 2000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   style: {
      //     background: "Red",
      //     color: "white",
      //   },
      // });
    }
  };

  getScrollData = (data) => {
    let scrollObj = localStorage.getItem("mac_state");
    if (scrollObj) {
      let obj = JSON.parse(localStorage.getItem("mac_state"));
      if (obj.AutoScroll) {
        data = [...data];
        if (
          obj.DisplayFor &&
          obj.DisplayFor !== "" &&
          obj.NumberOfMachine &&
          obj.NumberOfMachine !== ""
        ) {
          let endIndex =
            parseInt(localStorage.getItem("startIndex")) +
            parseInt(obj.NumberOfMachine);
          if (endIndex > data.length - 1) {
            data = data.slice(
              parseInt(localStorage.getItem("startIndex")),
              endIndex
            );
            localStorage.setItem("startIndex", 0);
          } else {
            data = data.slice(
              parseInt(localStorage.getItem("startIndex")),
              endIndex
            );
            localStorage.setItem("startIndex", endIndex);
          }
        }
      }
    }
    return data;
  };

  ScreensInterval;

  displayFor = () => {
    let autoScrollObj = localStorage.getItem("mac_state");
    if (autoScrollObj) {
      autoScrollObj = JSON.parse(autoScrollObj);
      if (
        autoScrollObj.DisplayFor &&
        autoScrollObj.DisplayFor != "" &&
        autoScrollObj.NumberOfMachine &&
        autoScrollObj.NumberOfMachine != ""
      ) {
        this.ScreensInterval = setInterval(() => {
          let obj = JSON.parse(localStorage.getItem("mac_state"));
          if (obj.AutoScroll) {
            let data = [...this.state.cacheData];
            if (obj.DisplayFor && obj.DisplayFor !== "") {
              let endIndex =
                parseInt(localStorage.getItem("startIndex")) +
                parseInt(obj.NumberOfMachine);
              if (endIndex > data.length - 1) {
                data = data.slice(
                  parseInt(localStorage.getItem("startIndex")),
                  endIndex
                );
                localStorage.setItem("startIndex", 0);
              } else {
                data = data.slice(
                  parseInt(localStorage.getItem("startIndex")),
                  endIndex
                );
                localStorage.setItem("startIndex", endIndex);
              }
            } else {
              data = data.slice(0, parseInt(autoScrollObj.NumberOfMachine));
            }
            data = this.organiseTimeLineData(data);
            this.setState(
              {
                timeLineData: data,
                autoScrolObj: JSON.parse(localStorage.getItem("mac_state")),
              },
              () => {
                if (
                  JSON.stringify(this.state.autoScrolObj) !==
                  localStorage.getItem("mac_state")
                ) {
                  this.ScreensInterval = null;
                  clearInterval(this.ScreensInterval);
                  this.displayFor();
                }
              }
            );
          } else {
            this.ScreensInterval = null;
            clearInterval(this.ScreensInterval);

            this.setState({
              timeLineData: this.organiseTimeLineData(this.state.cacheData),
            });
          }
        }, parseInt(autoScrollObj.DisplayFor) * 1000);
      }
    }
  };
  async componentDidMount() {
    this._isMounted = true;
    localStorage.setItem("startIndex", 0);

    /////////////////////////////////////////////// Change batchSize to vary the amount of equipment send through Api /////////////////////////////////////
    const batchSize = LIVE_BATCH_SIZE;

    //  window.addEventListener('scroll', this.handleScroll);
    if (this.props.reportType == "History") {
      const JobView = { ...this.state.JobView };
      const jobView = { ...this.props.jobView };
      if (jobView) {
        JobView.JobView = this.props.jobView.JobView;
        let res = [];
        if (this.props.jobView.JobView) {
          res = this.organiseTimeLineDataWithJobs(this.props.data);
        } else {
          res = this.organiseTimeLineData(this.props.data);
        }

        this.setState({
          timeLineData: res,
          JobView: JobView,
          rawData: this.props.data,
          rowHeight: res.length,
          networkError: false
        });
      } else {
        let res = this.organiseTimeLineData(this.props.data);
        this.setState({
          timeLineData: res,
          rawData: this.props.data,
          rowHeight: res.length,
          networkError: false
        });
      }
      this.fetchRelayOverlay(this.props.data);
    } else {
      this.setState({ querySuccess: true, networkError: false });

      let equips = [];
      // Check if data exists in local storage
      // const storedEquipGroupsData = localStorage.getItem('equipment');
      const Equipment = await this.props.storeDataInLocalStorage("equipment");
      equips = Equipment.filter(one => one.IsActive)

      let user = auth.getCurrentUser();

      // // consol(BatchSize,"BatchSize")
      for (let i = 0; i < Math.ceil(equips?.length / batchSize); i++) {
        if (!this._isMounted) {
          break;
        }
        let startIndex = i * batchSize;
        let endIndex = (i + 1) * batchSize;
        let senddata = equips.slice(startIndex, endIndex);
        ////////////////// compressed data with pako ///////////////
        const compressedData = pako.gzip(
          JSON.stringify({ UserId: user._id, Equips: senddata })
        );
        try {
          /////////////////////////// previous sending method without compression ////////////////////////
          // let result = await axios.put(api.liveBaseURL + 'GetMachineActvityForLiveReport', { UserId: user._id, Equips: senddata });

          ///////////////////////////////////// current sending  method with comprtession(pako:gzip) /////////////////
          let result = await axios.put(
            api.liveBaseURL + "GetMachineActvityForLiveReport",
            compressedData,
            {
              headers: {
                "Content-Encoding": "gzip", // Set the content encoding to gzip
                "Content-Type": "application/json", // Set the content type to JSON
              },
            }
          );
          /////////////////////////// de compressing the recived result  data ////////////

          const decompressedData = decodeJson(result.data);

          ///////////////////////////// conevrting sting into json ///////////
          const jsonData = decompressedData;

          let raw = [...jsonData, ...this.state.rawData];
          result = this.getFilterData(raw, this.props.filterObj);
          if (this.props.filterObj.JobView) {
            result = this.organiseTimeLineDataWithJobs(result);
          } else {
            result = this.organiseTimeLineData(result);
          }

          //result=[...result,...this.state.timeLineData]
          this.setState({
            timeLineData: result,
            rowHeight: result.length,
            rawData: raw,
            cacheData: raw,
            filterBy: this.props.filterBy,
            filterObj: this.props.filterObj,
            requestNumber: 1,
            networkError: false,
          });
        } catch (err) {
          if (
            err.response &&
            err.response.data &&
            err.response.data.code == 901
          ) {
            // swal(`${err.response.data.message}`);
          } else {
            // toast.success(`${err}`, {
            //   position: "bottom-right",
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: "Red", // Set your desired background color
            //     color: "white", // Set your desired text color
            //   },
            // });
            // swal(`${err}`)
          }
          this.setState({ querySuccess: false, networkError: true });
        }
      }

      this.setState({ querySuccess: false, lastUpdatedTime: new Date(), networkError: false });
      this.fetchRelayOverlay(this.state.rawData);

      const refreshMs = RefreshRate(this.props.company);
      const initialSeconds = Math.max(1, Math.floor(refreshMs / 1000));
      // save refresh interval to state (non-UI related)
      this.setState({ refreshIntervalMs: refreshMs, lastUpdatedTime: new Date(), networkError: false });

      // Initialize countdown without state
      this.currentCountdown = initialSeconds;
      this.updateCountdownDisplay(this.currentCountdown);

      this.MyInterval = setInterval(() => {
        if (!this._isMounted) return;

        // skip countdown ticks while a refresh is in progress
        if (this.isRefreshing) return;

        // pause the countdown (and so the polling) while the tab is hidden
        if (document.hidden) return;

        this.currentCountdown--;

        // if countdown still above zero, just update display
        if (this.currentCountdown > 0) {
          this.updateCountdownDisplay(this.currentCountdown);
          return;
        }

        // countdown hit zero: show 0 and refresh
        this.updateCountdownDisplay(0);
        this.isRefreshing = true;

        // trigger refresh asynchronously
        (async () => {
          try {
            await this.refreshLiveData();
          } catch (e) {
            console.error("refreshLiveData error:", e);
          } finally {
            if (!this._isMounted) return;
            this.isRefreshing = false;
            // reset countdown after refresh completes
            this.currentCountdown = Math.max(1, Math.floor(refreshMs / 1000));
            this.updateCountdownDisplay(this.currentCountdown);
          }
        })();
      }, 1000);

      // ---------- end replaced block ----------

    }
    // console.log("componet Did update4");

    if (this.props.reportType !== "History") {
      this.displayFor();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    // Optional: console log for debugging
    console.log('Clearing all intervals...');
    //  this.source.cancel("Component unmounted, request cancelled.");
    if (this.MyInterval) {
      clearInterval(this.MyInterval);
      this.MyInterval = null; // Optional: clear reference
    }

    if (this.ScreensInterval) {
      clearInterval(this.ScreensInterval);
      this.ScreensInterval = null; // Optional: clear reference
    }
    this.setState = () => { }; // Prevent setState on unmounted component
  }

  getCurrentDateTime = (dateTime) => {
    let currentDate = new Date(dateTime);
    // currentDate.setHours(currentDate.getHours()+5);
    // currentDate.setMinutes(currentDate.getMinutes()+30);
    let CurrentDateTime =
      currentDate.getDate() +
      "-" +
      ("0" + (currentDate.getMonth() + 1)).slice(-2) +
      "-" +
      currentDate.getFullYear() +
      "   |   " +
      currentDate.getHours() +
      ":" +
      (currentDate.getMinutes() < 10 ? "0" : "") +
      currentDate.getMinutes();
    //   ":" +
    //   currentDate.getSeconds();
    return CurrentDateTime;
  };

  getTimeDuration = (start, end) => {
    let from = new Date(start);
    let till = new Date(end);

    //  let duration=new Date(till.getTime()-from.getTime()).getHours()<=0?new Date(till.getTime()-from.getTime()).getMinutes()+' '+'Mins':new Date(till.getTime()-from.getTime()).getHours()+' '+'Hours, '+new Date(till.getTime()-from.getTime()).getMinutes()+' '+'Mins';
    let duration = Math.round(
      Math.abs(new Date(till.getTime() - from.getTime()) / 6e4)
    );
    let min = duration % 60;
    let hour = Math.floor(duration / 60);

    return `${hour} Hour ` + ` ${min} Min`;
  };

  fetchRelayOverlay = async (list) => {
    if (!this.props.showRelay || !Array.isArray(list) || list.length === 0) return;

    const equipments = Array.from(new Set(list.map((one) => one.Equipment).filter(Boolean)));
    let from = null;
    let till = null;
    list.forEach((one) => {
      (one.ListOfEvents || []).forEach((evt) => {
        const start = new Date(evt.From).getTime();
        const end = new Date(evt.Till).getTime();
        if (!isNaN(start) && (from === null || start < from)) from = start;
        if (!isNaN(end) && (till === null || end > till)) till = end;
      });
    });
    if (!equipments.length || from === null || till === null) return;
    // Live view: stretch to "now" so a relay that is still OFF reaches the current time.
    if (this.props.reportType !== "History") till = Math.max(till, Date.now());

    const requestId = ++this.relayRequestId;
    try {
      const { data } = await axios.put(api.dataEntryUrl + "relay-logs/mine/overlay", {
        equipments,
        from: new Date(from).toISOString(),
        till: new Date(till).toISOString(),
      });
      if (!this._isMounted || requestId !== this.relayRequestId) return;
      const relayOverlay = {
        connected: (data && data.connected) || [],
        intervals: (data && data.intervals) || [],
      };
      this.setState({ relayOverlay }, () => {
        this.setState({ timeLineData: this.applyRelayOverlay(this.state.timeLineData) });
      });
    } catch (err) {
      // Relay data is supplementary; the chart keeps working without it.
    }
  };

  buildRelayTooltip = (interval) => {
    const channel = [interval.RelayChannel, interval.Signal].filter(Boolean).join(" / ");
    const reasonRow = interval.State === "OFF"
      ? `<tr><td>Reason</td><td>${escapeHtml(interval.Reason || "-")}</td></tr>`
      : "";
    return `<div style="padding: 5px; width: 220px; background-color: rgba(111, 66, 193, 0.12); border-radius: 10px; overflow: hidden;"><table><tr><td>Machine</td><td>${escapeHtml(
      interval.Equipment
    )}</td></tr><tr><td>Event</td><td>Relay ${escapeHtml(interval.State)}</td></tr><tr><td>Channel</td><td>${escapeHtml(
      channel || "-"
    )}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(interval.From)}</td></tr><tr><td>Till</td><td>${interval.Ongoing ? "Ongoing" : this.getCurrentDateTime(interval.Till)
      }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(interval.From, interval.Till)}</td></tr>${reasonRow}</table></div>`;
  };

  // Replaces any relay rows in a timeline array with the current relay state windows, only for
  // machines that already have a row (so filters / auto-scroll slices are respected).
  applyRelayOverlay = (timeLineArray) => {
    if (!Array.isArray(timeLineArray) || timeLineArray.length === 0) return timeLineArray;
    const rows = timeLineArray.filter((row) => !isRelayRow(row));
    if (!this.props.showRelay || !this.props.showRelayStates) return rows;

    const { intervals } = this.state.relayOverlay;
    const machines = new Set(rows.slice(1).map((row) => row[0]));
    intervals.forEach((interval) => {
      if (!machines.has(interval.Equipment) || !RELAY_STATE_COLORS[interval.State]) return;
      rows.push([
        interval.Equipment,
        `Relay ${interval.State} - ${interval.RelayChannel || ""}`,
        this.buildRelayTooltip(interval),
        RELAY_STATE_COLORS[interval.State],
        new Date(interval.From),
        new Date(interval.Till),
        "",
      ]);
    });
    return rows;
  };

  // Row labels are drawn by Google Charts as SVG <text>; restyling them leaves the data
  // (row[0] is the equipment key used by the downtime entry handlers) untouched.
  highlightRelayRows = () => {
    if (!this.props.showRelay) return;
    const connected = new Set(this.state.relayOverlay.connected);
    if (connected.size === 0) return;
    const container = document.getElementById("timeline");
    if (!container) return;
    container.querySelectorAll("svg text").forEach((node) => {
      const label = node.textContent || "";
      if (label.startsWith(RELAY_LABEL_MARK) || !connected.has(label)) return;
      node.textContent = RELAY_LABEL_MARK + label;
      node.setAttribute("fill", RELAY_LABEL_COLOR);
      node.setAttribute("font-weight", "bold");
    });
  };

  organiseTimeLineData = (list) => {
    // console.log("vkjvnkvnkjvnk",list,this.props.reportType,this.props.id)

    if (this.props.reportType == "History" && this.props.id !== "reporting") {
      let dataList = [...list];
      list = [];
      this.props.equipGroups.forEach((one) => {
        let filterResult = dataList.filter(
          (obj) => obj.EquipmentGroup == one.name && one.enable
        );
        list = [...list, ...filterResult];
      });
    }
    list.sort(function (a, b) {
      if (a.Equipment < b.Equipment) {
        return -1;
      }
      if (a.Equipment > b.Equipment) {
        return 1;
      }
      return 0;
    });
    let timeLineArray = [];
    let chartSchema = [
      { type: "string", id: "MachineName" },
      { type: "string", id: "State" },
      { type: "string", role: "tooltip", p: { html: true } },
      { type: "string", role: "style" },
      { type: "date", id: "Start" },
      { type: "date", id: "End" },
      { type: "string", role: "ActionTaken" },

    ];
    timeLineArray.push(chartSchema);
    let machineNameArray = [];

    for (let i = 0; i < list.length; i++) {
      let machineName = list[i].Equipment;

      for (let j = 0; j < list[i].ListOfEvents.length; j++) {
        var oneArray = [];
        oneArray.push(machineName);
        if (list[i].ListOfEvents[j].State == "Running") {
          if (
            list[i].ListOfEvents[j].DowntimeReason == null ||
            list[i].ListOfEvents[j].DowntimeReason == "null"
          ) {
            oneArray.push(list[i].ListOfEvents[j].State);
            oneArray.push(
              `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].From
              )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].Till
              )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
              }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
                list[i].ListOfEvents[j].From,
                list[i].ListOfEvents[j].Till
              )}</td></tr></table></div>`
            );
            oneArray.push("#0F9D58");
          } else {
            oneArray.push(list[i].ListOfEvents[j].State);
            oneArray.push(
              `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].From
              )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].Till
              )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
              }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
                list[i].ListOfEvents[j].From,
                list[i].ListOfEvents[j].Till
              )}</td></tr></table></div>`
            );
            oneArray.push("#F4B400");
          }
        } else if (list[i].ListOfEvents[j].State == "Down") {
          oneArray.push(list[i].ListOfEvents[j].State);
          oneArray.push(
            `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].From
            )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
            }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
              list[i].ListOfEvents[j].From,
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td >Remarks</td><td>${list[i].ListOfEvents[j].Remarks || "-"
            }</td></tr>
            <tr><td >Last Updated By</td><td>${list[i].ListOfEvents[j].LastUpdatedBy || "-"
            }</td></tr>
            <tr><td >Last Updated At</td><td>${list[i].ListOfEvents[j].LastUpdated
              ? this.getCurrentDateTime(list[i].ListOfEvents[j].LastUpdated)
              : "-"
            }</td></tr></table></div>`
          );
          oneArray.push("#DB4437");
        } else if (list[i].ListOfEvents[j].State == "Break") {
          oneArray.push(list[i].ListOfEvents[j].State);
          oneArray.push(
            `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].From
            )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
            }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
              list[i].ListOfEvents[j].From,
              list[i].ListOfEvents[j].Till
            )}</td></tr></table></div>`
          );
          oneArray.push("#F4B400");
        } else {
          // Google Timeline throws on a null bar label, so never pass a missing State through.
          oneArray.push(list[i].ListOfEvents[j].State || list[i].ListOfEvents[j].SystemState || "Unknown");
          oneArray.push(
            `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td>Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].From
            )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
            }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
              list[i].ListOfEvents[j].From,
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td >Remarks</td><td>${list[i].ListOfEvents[j].Remarks || "-"
            }</td></tr>
            <tr><td >Updated By</td><td>${list[i].ListOfEvents[j].LastUpdatedBy || "-"
            }</td></tr>
            <tr><td >Updated At</td><td>${list[i].ListOfEvents[j].LastUpdated
              ? this.getCurrentDateTime(list[i].ListOfEvents[j].LastUpdated)
              : "-"
            }</td></tr>
            <tr><td >Action Taken</td><td>${list[i].ListOfEvents[j].actionTaken
              ? list[i].ListOfEvents[j].actionTaken
              : "-"
            }</td></tr>
            </table></div>`
          );
          oneArray.push(list[i].ListOfEvents[j].Color);
        }

        // let from=new Date(this.props.timeLineData[i].ListOfEvents[j].From);
        // let to=this.props.timeLineData[i].ListOfEvents[j].Till===undefined?new Date():new Date(this.props.timeLineData[i].ListOfEvents[j].Till);
        oneArray.push(new Date(list[i].ListOfEvents[j].From));
        oneArray.push(new Date(list[i].ListOfEvents[j].Till));
        oneArray.push(list[i].ListOfEvents[j].actionTaken || '');

        // let dateFrom=new Date(this.props.timeLineData[i].ListOfEvents[j].From);

        // oneArray.push(dateFrom.getDate()+'-'+(dateFrom.getMonth()+1)+'-'+dateFrom.getFullYear());
        timeLineArray.push(oneArray);
      }
    }

    return this.applyRelayOverlay(timeLineArray);
  };

  organiseTimeLineDataWithJobs = (list) => {
    if (this.props.reportType == "History" && this.props.id !== "reporting") {
      let dataList = [...list];
      list = [];
      this.props.equipGroups.forEach((one) => {
        let filterResult = dataList.filter(
          (obj) => obj.EquipmentGroup == one.name && one.enable
        );
        list = [...list, ...filterResult];
      });
    }
    list.sort(function (a, b) {
      if (a.Equipment < b.Equipment) {
        return -1;
      }
      if (a.Equipment > b.Equipment) {
        return 1;
      }
      return 0;
    });
    let timeLineArray = [];
    let chartSchema = [
      { type: "string", id: "MachineName" },
      { type: "string", id: "State" },
      { type: "string", role: "tooltip", p: { html: true } },
      { type: "string", role: "style" },
      { type: "date", id: "Start" },
      { type: "date", id: "End" },
      { type: "string", role: "ActionTaken" },
    ];
    timeLineArray.push(chartSchema);
    let machineNameArray = [];

    for (let i = 0; i < list.length; i++) {
      let machineName = list[i].Equipment;

      for (let j = 0; j < list[i].ListOfEvents.length; j++) {
        var oneArray = [];
        oneArray.push(machineName);
        if (list[i].ListOfEvents[j].State == "Running") {
          if (
            list[i].ListOfEvents[j].DowntimeReason == null ||
            list[i].ListOfEvents[j].DowntimeReason == "null"
          ) {
            oneArray.push(list[i].ListOfEvents[j].State);
            oneArray.push(
              `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].From
              )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].Till
              )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
              }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
                list[i].ListOfEvents[j].From,
                list[i].ListOfEvents[j].Till
              )}</td></tr></table></div>`
            );
            oneArray.push("#0F9D58");
          } else {
            oneArray.push(list[i].ListOfEvents[j].State);
            oneArray.push(
              `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].From
              )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
                list[i].ListOfEvents[j].Till
              )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
              }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
                list[i].ListOfEvents[j].From,
                list[i].ListOfEvents[j].Till
              )}</td></tr></table></div>`
            );
            oneArray.push("#F4B400");
          }
        } else if (list[i].ListOfEvents[j].State == "Down") {
          oneArray.push(list[i].ListOfEvents[j].State);
          oneArray.push(
            `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].From
            )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
            }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
              list[i].ListOfEvents[j].From,
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td >Remarks</td><td>${list[i].ListOfEvents[j].Remarks || "-"
            }</td></tr>
            <tr><td >Last Updated By</td><td>${list[i].ListOfEvents[j].LastUpdatedBy || "-"
            }</td></tr>
            <tr><td >Last Updated At</td><td>${list[i].ListOfEvents[j].LastUpdated
              ? this.getCurrentDateTime(list[i].ListOfEvents[j].LastUpdated)
              : "-"
            }</td></tr></table></div>`
          );
          oneArray.push("#DB4437");
        } else if (list[i].ListOfEvents[j].State == "Break") {
          oneArray.push(list[i].ListOfEvents[j].State);
          oneArray.push(
            `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 10px; overflow: hidden;"><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].From
            )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
            }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
              list[i].ListOfEvents[j].From,
              list[i].ListOfEvents[j].Till
            )}</td></tr></table></div>`
          );
          oneArray.push("#F4B400");
        } else {
          oneArray.push(list[i].ListOfEvents[j].State || list[i].ListOfEvents[j].SystemState || "Unknown");
          oneArray.push(
            `<div style="padding: 5px; width: 200px; background-color: rgba(199, 236, 199, 0.4); border-radius: 30px; overflow: hidden;"><table><tr><td>Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].From
            )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td>Event</td><td>${list[i].ListOfEvents[j].State
            }</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
              list[i].ListOfEvents[j].From,
              list[i].ListOfEvents[j].Till
            )}</td></tr><tr><td >Remarks</td><td>${list[i].ListOfEvents[j].Remarks || "-"
            }</td></tr>
            <tr><td >Updated By</td><td>${list[i].ListOfEvents[j].LastUpdatedBy || "-"
            }</td></tr>
            <tr><td >Updated At</td><td>${list[i].ListOfEvents[j].LastUpdated
              ? this.getCurrentDateTime(list[i].ListOfEvents[j].LastUpdated)
              : "-"
            }</td></tr>
            <tr><td >Action Taken</td><td>${list[i].ListOfEvents[j].actionTaken
              ? list[i].ListOfEvents[j].actionTaken
              : "-"
            }</td></tr>
            </table></div>`
          );
          oneArray.push(list[i].ListOfEvents[j].Color);
        }

        // let from=new Date(this.props.timeLineData[i].ListOfEvents[j].From);
        // let to=this.props.timeLineData[i].ListOfEvents[j].Till===undefined?new Date():new Date(this.props.timeLineData[i].ListOfEvents[j].Till);
        oneArray.push(new Date(list[i].ListOfEvents[j].From));
        oneArray.push(new Date(list[i].ListOfEvents[j].Till));
        oneArray.push(list[i].ListOfEvents[j].actionTaken || '');

        // let dateFrom=new Date(this.props.timeLineData[i].ListOfEvents[j].From);

        // oneArray.push(dateFrom.getDate()+'-'+(dateFrom.getMonth()+1)+'-'+dateFrom.getFullYear());
        timeLineArray.push(oneArray);
      }
      //State Event Eend

      //Jobs Array Start
      if (list[i].Jobs) {
        for (let j = 0; j < list[i].Jobs.length; j++) {
          var oneArray = [];
          oneArray.push(machineName);
          let job =
            "Job - " +
            list[i].Jobs[j].Component +
            " | " +
            list[i].Jobs[j].OperationID +
            " | " +
            (list[i].Jobs[j].ToolID !== "null" ? list[i].Jobs[j].ToolID : "NA");
          oneArray.push(job);
          oneArray.push(
            `<p><table><tr><td >Machine</td><td>${machineName}</td></tr><tr><td>From</td><td>${this.getCurrentDateTime(
              list[i].Jobs[j].From
            )}</td></tr><tr><td>Till</td><td>${this.getCurrentDateTime(
              list[i].Jobs[j].Till
            )}</td></tr><tr><td>Event</td><td>${job}</td></tr><tr><td>Duration</td><td>${this.getTimeDuration(
              list[i].Jobs[j].From,
              list[i].Jobs[j].Till
            )}</td></tr></table></p>`
          );
          oneArray.push(this.getRandomColor(1, 4));
          oneArray.push(new Date(list[i].Jobs[j].From));
          oneArray.push(new Date(list[i].Jobs[j].Till));
          oneArray.push('');
          timeLineArray.push(oneArray);
        }
      }

      ///Job Array End
    }

    return this.applyRelayOverlay(timeLineArray);
  };

  getRandomColor = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    let randNum = Math.floor(Math.random() * (max - min + 1)) + min;
    let objKeys = Object.keys(api.JobColour[randNum]);
    return api.JobColour[randNum][objKeys[0]];
  };





  updateChartEvent = (str) => {
    let requestNumber = { ...this.state.requestNumber };
    requestNumber++;
    this.setState({ requestNumber });
    this.props.handleChartEvent(
      str,
      this.state.rawData,
      this.state.timeLineData
    );
  };

  chartEvents = [
    {
      eventName: "ready",
      callback: ({ chartWrapper, google }) => {
        const chart = chartWrapper.getChart();
        this.highlightRelayRows();
        //chart.setSelection([{row:800,column:null}])
        // var chartWrapper = new google.visualization.ChartWrapper({
        //   chartType: 'Timeline',
        //   dataTable: this.state.timeLineData,
        //   containerId: 'timeline'
        // });
        // chartWrapper.draw();
        // google.visualization.events.removeListener()
        if (this.state.requestNumber <= 1) {
          if (!this.props.systemGenerated) {
            google.visualization.events.addListener(chart, "select", (e) => {
              //const { row, column } = e;
              const data = this.state.timeLineData;
              // // consol($('#timeline').scrollTop())
              let selection = chart.getSelection();
              for (var i = 0; i < selection.length; i++) {
                var item = selection[i];
                if (item.row != null) {
                  var str = data[item.row + 1];
                  // Relay OFF bars are informational only - never a downtime entry target.
                  if (isRelayRow(str)) continue;
                  if (this.props.id == "Downtime") {
                    if (
                      this.props.entryType.Multiple ||
                      this.props.entryType.Multiple == "true"
                    ) {
                      this.updateSelectableEventColor(item.row + 1);
                    }
                    this.updateChartEvent(str);
                  }
                }
              }
            });
            //   google.visualization.events.addListener(chart, "onmouseover", e => {
            //     //const { row, column } = e;
            //  // consol(this.chartref.current)

            //   });
            //   google.visualization.events.addListener(chart, "onmouseover", e => {
            //     //const { row, column } = e;
            //     $('#timeline').scrollTop(this.state.timeLinePos)

            //   });
          }
        }
      },
    },
  ];

  updateSelectableEventColor = (row) => {
    const data = [...this.state.timeLineData];
    let str = data[row];
    // Block selection if last state is Running
    const updateEventMultiple = [...this.props.updateEventMultiple];
    let filer = updateEventMultiple.filter(
      (one) =>
        this.props.getSystemState(one) == this.props.getSystemState(data[row])
    );
    let events = str[1].split("-");
    if (events[0].trim() !== "Job") {
      if (updateEventMultiple.length == 0) {
        data[row][3] = "gray";
        this.setState({ timeLineData: data });
      } else {
        if (filer.length > 0) {
          data[row][3] = "gray";
          this.setState({ timeLineData: data });
        } else {
          //this.setState({ systemGenerated: true });
        }
      }
    }

    // const data = [...this.state.timeLineData];
    // data[row][3] = 'gray';
    // this.setState({ timeLineData: data })
  };
  handelQuickReport = () => {

  }
  render() {
    // TuiChart.registerTheme("newTheme",this.theme);

    // if (typeof this.state.timeLineData === typeof "")
    //   return <h3>{this.state.timeLineData}</h3>;

    if (this.state.timeLineData.length <= 1 && !this.state.querySuccess && !this.state.networkError) {
      return <p>No Data Available </p>;
    }
    if (this.props.reportType !== "History" && !this.state.querySuccess && this.state.networkError) {
      return <div>
        <div className="alert alert-danger" role="alert">
          Network Error! Unable to fetch data. Please check your internet connection.
        </div>
      </div>;
    }


    // localStorage.setItem("Machinestatechartheight",(this.props.equipList.length)*50 );
    // const height =localStorage.getItem("Machinestatechartheight")

    // if(this.chartref.current && this.chartref.current._isMounted){
    //   return <p>loading....</p>
    // }

    return (
      //TuiChart.registerTheme("color",theme)
      <>

        {this.props.refresh && <div
          style={{
            position: "absolute",
            top: 9,
            left: "50%",                    // center horizontally
            transform: "translateX(-50%)",  // adjust for element width
            minWidth: 220,                  // optional: ensure it doesn't get too narrow
            width: "auto",
            textAlign: "center",            // center inner text
            zIndex: 50                       // keep it above other elements if needed
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <div
            style={{ verticalAlign: "middle" }}
            className="mt-1 small d-flex justify-content-between align-items-center"
          >
            <h6
              ref={this.countdownRef}
              className="small text-muted ms-3"
              style={{ color: "#555", fontWeight: "bold", lineHeight: 1, marginTop: 6 }}
            >
              Refresh in 0s
            </h6>

            {this.state.lastUpdatedTime && (
              <div className="small text-muted ms-3" style={{ color: "#555", fontWeight: "bold", lineHeight: 1 }}>
                Last updated{" "}
                {this.state.lastUpdatedTime.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </div>
            )}
          </div>

        </div>}

        {/*       
     {this.state.favourate == false ? <FontAwesomeIcon 
      icon={faStar} 
      onClick={()=>{this.setState({favourate:true})}} 
      style={{ cursor: "pointer", color: "gold", fontSize: "24px" }}
    />:
    <FontAwesomeIcon icon={faStar}   onClick={()=>{this.setState({favourate:false})}}  style={{ cursor: "pointer", fontSize: "24px" }} />}
       */}
        {this.state.querySuccess ? (
          <TopStripLoader valueNow={this.state.rawData.length} valueMax={this.props.equipList.length}
            showPercent={false}
            height="20px"
            fontSize="1.2rem"
          />
          // <Loading
          //   labelShow={true}
          //   label={`${this.state.rawData.length}/${this.props.equipList.length}`}
          // />
        ) : (
          ""
        )}
        {/* {!this.props.hideHeader && <div className="chart-header" style={{ textAlign: 'center', marginBottom: 6 }}>
          <div>Machine State Chart / 4M Change Monitor</div>
        </div>} */}

        {this.props.showRelay && this.state.relayOverlay.connected.length > 0 && (
          <div className="d-flex align-items-center small" style={{ gap: 16, marginBottom: 6, color: "#555" }}>
            <span style={{ color: RELAY_LABEL_COLOR, fontWeight: "bold" }}>{RELAY_LABEL_MARK}Relay-connected machine</span>
            {this.props.showRelayStates && Object.keys(RELAY_STATE_COLORS).map((state) => (
              <span key={state} className="d-flex align-items-center" style={{ gap: 6 }}>
                <span style={{ display: "inline-block", width: 18, height: 10, borderRadius: 2, background: RELAY_STATE_COLORS[state] }} />
                Relay {state}
              </span>
            ))}
            {this.props.showRelayStates && <span>(hover a relay bar for channel / reason)</span>}
          </div>
        )}

        {this.state.rawData.length > 0 ? (
          <div ref={this.scrollContainerRef}>

            <Chart
              // height={`${height}px`}
              height={"1500px"}
              // height={window.screen.availHeight-(window.screen.availHeight/3)}
              width={this.props.toggle ? 'calc(100% - 250px)' : '100%'}
              //style={{minHeight:500}}
              // style={{width:'100%',}
              ref={this.chartref}
              graphID="timeline"
              style={{
                width: "100%",
                marginRight: 5,
                // height: window.screen.height - window.screen.height / 3
              }}
              chartEvents={this.chartEvents}
              chartType="Timeline"
              loader={<div>Loading Chart</div>}
              data={this.state.timeLineData}
              options={{
                tooltip: { isHtml: true },
                //chartArea:{width:'100%',height:'100%'}
                timeline: {
                  rowLabelStyle: { fontSize: 15 }, //9
                  barLabelStyle: { fontSize: 8 }, //8
                },
              }}
              rootProps={{ "data-testid": "3" }}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}
